export default __webpack_public_path__ + "static/logo-black-a2cec038ee73815bb85297b64093bf96.svg";